let toast;

export const setToastRef = (ref) => {
    toast = ref;
};

export const showSuccessToast = (message) => {
    if (toast) {
        toast.show({
            severity: 'success',
            life: 3000,
            content: (
                <div className='center_toast'>
                    <img
                        src='/assets/success_icon.svg'
                        style={{ marginRight: '0.5rem' }}
                    />
                    <div>{message}</div>
                </div>
            ),
        });
    }
};

export const showErrorToast = (message) => {
    if (toast) {
        toast.show({
            severity: 'error',
            life: 3000,
            content: (
                <div className='center_toast'>
                    <img
                        src='/assets/error_icon.svg'
                        style={{ marginRight: '0.5rem' }}
                    />
                    <div>{message}</div>
                </div>
            ),
        });
    }
};

export const setToastComponent = (component) => {
    setToastRef(component);
};
